import { connect } from 'react-redux';

import { actions, selectors } from '../../redux/snackbar';

import SnackbarContainer from './SnackbarContainer';

const mapStateToProps = state => ({
    snackbars: selectors.getSnackbars(state),
});

const mapDispatchToProps = dispatch => ({
    hideSnackbar: snackbarId => dispatch(actions.hideSnackbar(snackbarId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SnackbarContainer);
